import { get as networkGet, patch as networkPatch } from '../../networkClient';

/**
 * Fetches Kelsey-missed queries the agent has not yet answered, for a lead.
 *
 * @param {string} leadId
 * @returns {Promise<Array>} The list of unanswered queries
 */
export async function getUnansweredLeadQueries(leadId) {
  const response = await networkGet(
    `/leads/${leadId}/kelsey-missed-queries`,
    { hasAgentAnswered: false },
    null,
    true,
    true
  );
  return response?.data?.data ?? [];
}

/**
 * Marks a missed query as agent-answered. Agent identity is resolved
 * server-side from the authenticated user.
 *
 * @param {string} leadId
 * @param {string} queryId
 * @returns {Promise<Object>} The updated query record
 */
export async function markLeadQueryAnswered(leadId, queryId) {
  const response = await networkPatch(
    `/leads/${leadId}/kelsey-missed-queries/${queryId}`,
    { hasAgentAnswered: true },
    null,
    null,
    true,
    true
  );
  return response?.data?.data;
}
